// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"b29213d8","547":"6fe8990d","882":"d9ee74e9"}[chunkId] + ".chunk.css";
};